import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Signup from './Signup';
import Login from './Login';
import Dashboard from './Dashboard';
import ManageEAs from './ManageEAs';
import GenerateKeys from './GenerateKeys';
import DisplayKeys from './DisplayKeys';
import Home from './Home'; // ✅ Add this
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/manage-eas" element={<ManageEAs />} />
        <Route path="/generate-keys" element={<GenerateKeys />} />
        <Route path="/display-keys" element={<DisplayKeys />} />
        <Route path="/home" element={<Home />} /> {/* ✅ Add this line */}
        <Route path="*" element={<Navigate to="/Home" replace />} />
      </Routes>
    </Router>
  );
}

export default App;